export class Parceiro {
  constructor(parceiroForm: any) {
    this.nome = parceiroForm.nome;
    this.imagemSrc = parceiroForm.imagemSrc;
    this.cnpj = parceiroForm.cnpj;
    this.idStatus = parceiroForm.idStatus;
    this.parceiroEndereco = [];
    this.urlSite = parceiroForm.urlSite;
    this.redesSociais = parceiroForm.redesSociais;
    this.numeroSeguidores = parceiroForm.numeroSeguidores;
    this.linkedIn = parceiroForm.linkedIn;
    this.idTipoParceria = parceiroForm.idTipoParceria;
    this.nomeContato = parceiroForm.nomeContato;
    this.telefoneContato = parceiroForm.telefoneContato;
    this.emailContato = parceiroForm.emailContato;
    this.observacoes = parceiroForm?.obervacoes;
    this.hashIndicacao = '';
  }

  nome!: string;
  cnpj!: string;
  imagemSrc!: string;
  idStatus!: number;
  parceiroEndereco!: any[];
  urlSite: string;
  redesSociais: string;
  nomeContato: string;
  telefoneContato: string;
  emailContato: string;
  observacoes?: string;
  hashIndicacao!: string;
  numeroSeguidores: number;
  linkedIn: string;
  idTipoParceria: number;
}